
    import {defineComponent, reactive, toRefs, ComputedRef, computed, watch} from 'vue';
    import {useStore} from "@/store";

    interface CheckItemShow {
        Accident: boolean;
        Fire: boolean;
        SoakWater: boolean;
    }

    interface Item {
        checkItemCode: string;
        checkItemName: string;
        itemDesc: string;
        photoList: object[];
    }

    interface State {
        listName: string; // 列表名称
        listDefectNumber: number; // 总计标红的数量
        listSumNumber: number; // 总计检查项的数量
        importantNumber: number; // 总计重要检查项的数量
        defectList: Item[]; // 列表数据
        isShowAll: boolean; // 是否展开折叠
        checkItemShow: CheckItemShow;
    }

    export default defineComponent({
        name: "defectList",
        props: {
            defectData: {
                type: Object,
                default: () => {
                    return {};
                }
            }
        },
        setup(props) {
            let state: State = reactive({
                listName: '',
                listDefectNumber: 0,
                listSumNumber: 0,
                importantNumber: 0,
                defectList: [],
                isShowAll: false,
                checkItemShow: {
                    Accident: false,
                    Fire: false,
                    SoakWater: false,
                }
            })
            function SET_STATE(payload: any) {
                Object.keys(payload).forEach((key: string) => {
                    if (typeof payload[key] !== 'undefined') {
                        state[key] = payload[key];
                    }
                })
            }
            const {defectData} = toRefs(props)
            SET_STATE(defectData.value)
            let store = useStore()
            let checkItemShow: ComputedRef<{}> = computed<{}>(() => store.state.checkItemShow)
            watch(checkItemShow, (data: any) => {
                const {checkItemShow} = data;
                state.checkItemShow = checkItemShow
                if (state.listName === '事故检测') {
                    state.isShowAll = checkItemShow.Accident
                }
                if (state.listName === '火烧检测') {
                    state.isShowAll = checkItemShow.Fire
                }
                if (state.listName === '泡水检测') {
                    state.isShowAll = checkItemShow.SoakWater
                }
            })
            return {
                state,
                store
            }
        },
        methods: {
            changeIsShowAllState(checkItem) {
                this.state.isShowAll = !this.state.isShowAll
                let checkItemKey;
                switch (checkItem) {
                    case '事故检测' : 
                        checkItemKey = 'Accident';
                        break;
                    case '火烧检测' :
                        checkItemKey = 'Fire';
                        break;
                    case '泡水检测' :
                        checkItemKey = 'SoakWater';
                        break;
                }
                if (this.state.isShowAll) {
                    for (let key in this.state.checkItemShow) {
                        if(key === checkItemKey) {
                            this.state.checkItemShow[key] = this.state.isShowAll
                            setTimeout(() => {
                                location.hash = `#${checkItemKey}`
                            }, 50);
                        } else {
                            this.state.checkItemShow[key] = !this.state.isShowAll
                        }
                    }
                } else {
                    for (let key in this.state.checkItemShow) {
                        this.state.checkItemShow[key] = this.state.isShowAll
                    }
                }
                this.store.dispatch('saveCheckItemShow', {checkItemShow: this.state.checkItemShow})
            },
        }
    })
